module.exports = __webpack_public_path__ + "img/pci-booking.03a07d50.svg";